module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component__loader-spinner"
  }, [_c('div', {
    staticClass: "loader"
  }, [_c('svg', {
    staticClass: "circular",
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none",
      "stroke-width": "4",
      "stroke-miterlimit": "10"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ae58aee","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZLoaderSpinner.vue
// module id = 1205
// module chunks = 0